export enum DocumentType {
    DriverLicense = 'DRIVER_LICENCE',
    GovernmentId = 'GOVERNMENT_ID',
    Passport = 'PASSPORT',
    ResidencePermit = 'RESIDENCE_PERMIT',
    UtilityBill = 'UTILITY_BILL',
    Other = 'OTHER',
}
